import {BASE_URL} from '../utils/constant';
import {axiosClient} from './AxiosClient';
export const apiInstance = axiosClient(BASE_URL);
